import * as React from 'react';
import GET_COACH_PAUSE_REASONS from 'coaching/queries/GetCoachPauseReasons.gql';
import { ApolloError } from 'apollo-client';
import { Query } from 'react-apollo';
import {
  GetCoachPauseReasons,
  GetCoachPauseReasons_coaching_coachPauseReasons,
} from 'coaching/queries/__generated__/GetCoachPauseReasons';

export type Props = {
  children: (props: {
    pauseReasons: GetCoachPauseReasons_coaching_coachPauseReasons[];
    loading: boolean;
    error?: ApolloError;
  }) => React.ReactNode;
};

export default function CoachPauseReasonsContainer(props: Props) {
  return (
    <Query<GetCoachPauseReasons> query={GET_COACH_PAUSE_REASONS}>
      {({ loading, error, data }) => {
        return props.children({
          pauseReasons: data?.coaching_coachPauseReasons ?? [],
          loading,
          error,
        });
      }}
    </Query>
  );
}
